import React, {PropTypes} from 'react';
import ReimbursementSummaryAside from './reimbursement-summary-aside';
import ReimbursementSummaryMain from './reimbursement-summary-main';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

const Summary = props =>
    <section className='reimbursement-summary'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <ReimbursementSummaryAside
            pathName={props.location.pathname}
            queryParams={props.location.query}
        />
        {props.children || <ReimbursementSummaryMain/>}
    </section>;

Summary.displayName = 'Summary';
Summary.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    children: PropTypes.node,
    location: PropTypes.object.isRequired
};

export default Summary;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary.js